import { toast } from "react-toastify";
import { toastConfig } from "./toastConfig";

class ToastService {
  success(message, options = {}) {
    return toast.success(message, {
      ...toastConfig,
      ...options,
    });
  }

  error(message, options = {}) {
    return toast.error(message, {
      ...toastConfig,
      ...options,
    });
  }

  info(message, options = {}) {
    return toast.info(message, {
      ...toastConfig,
      ...options,
    });
  }

  warning(message, options = {}) {
    return toast.warning(message, {
      ...toastConfig,
      ...options,
    });
  }

  promise(promise, messages, options = {}) {
    return toast.promise(
      promise,
      {
        pending: messages.pending || "Processing...",
        success: messages.success || "Success!",
        error: messages.error || "Failed!",
      },
      {
        ...toastConfig,
        ...options,
      },
    );
  }

  dismiss(toastId) {
    if (toastId) {
      toast.dismiss(toastId);
    } else {
      toast.dismiss();
    }
  }

  dismissAll() {
    toast.dismiss();
  }
}

const toastService = new ToastService();
export default toastService;
